"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _curry = _interopRequireDefault(require("lodash/fp/curry"));
var _reverse = _interopRequireDefault(require("lodash/fp/reverse"));
var _getActiveElement = _interopRequireDefault(require("@active/react-utils/dom/getActiveElement"));
var _i18n = require("@active/react-utils/i18n");
var DateTimeSymbols = _interopRequireWildcard(require("@active/core/datetime/dateTimeSymbols"));
var _locale = require("@active/core/locale");
var _datetime = require("@active/core/datetime");
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _MenuItemList = _interopRequireDefault(require("../MenuItemList"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _excluded = ["registerValidate", "onChange", "value", "onBlur", "size", "className", "format", "displayFormat", "minYear"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var maxYear = new Date().getFullYear();
var createMenuDataList = function createMenuDataList(from, to) {
  var data = [];
  for (var i = from; i <= to; i += 1) {
    data.push({
      text: "".concat(i),
      value: "".concat(i)
    });
  }
  return data;
};
var getLastDayOfMonth = function getLastDayOfMonth(year, month) {
  return new Date(year, month, 0).getDate();
};
var createMenuDataListOfDays = function createMenuDataListOfDays(month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : maxYear;
  if (!month) {
    return createMenuDataList(1, 31);
  }
  return createMenuDataList(1, getLastDayOfMonth(year, month));
};
var createSequence = function createSequence(format) {
  return format.split(/[^YyMmDd]/).map(function (v) {
    return v.split('')[0].toUpperCase();
  }).map(function (v) {
    if (v === 'Y') {
      return 'year';
    }
    if (v === 'M') {
      return 'month';
    }
    return 'day';
  });
};
var splitDate = function splitDate(value, format) {
  if ((0, _datetime.isValid)(value, format)) {
    var datetime = (0, _datetime.toISO)(value, format);
    return {
      year: (0, _datetime.yearOf)(datetime),
      month: (0, _datetime.monthOf)(datetime),
      day: (0, _datetime.dayOf)(datetime)
    };
  }
  return {};
};
var isFullDate = function isFullDate(_ref) {
  var year = _ref.year,
    month = _ref.month,
    day = _ref.day;
  return !!(year && month && day);
};
var calculateValidDateSplitObj = function calculateValidDateSplitObj(dateSplitObj) {
  if (isFullDate(dateSplitObj)) {
    var year = dateSplitObj.year,
      month = dateSplitObj.month,
      day = dateSplitObj.day;
    var lastDayOfMonth = getLastDayOfMonth(year, month);
    var validDay = day > lastDayOfMonth ? lastDayOfMonth : day;
    return {
      year: year,
      month: month,
      day: validDay
    };
  }
  return dateSplitObj;
};
var getShortDateFormat = (0, _curry["default"])(_datetime.getFormat)(_datetime.DateTimeFormat.SHORT_DATE);
var DateOfBirthSelector = function DateOfBirthSelector(_ref2, ref) {
  var registerValidate = _ref2.registerValidate,
    onChange = _ref2.onChange,
    dobValue = _ref2.value,
    onBlur = _ref2.onBlur,
    size = _ref2.size,
    className = _ref2.className,
    _ref2$format = _ref2.format,
    propFormat = _ref2$format === void 0 ? 'MM/DD/YYYY' : _ref2$format,
    displayFormat = _ref2.displayFormat,
    _ref2$minYear = _ref2.minYear,
    minYear = _ref2$minYear === void 0 ? 1900 : _ref2$minYear,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var innerRef = _react["default"].useRef();
  var DobSelectorRef = ref !== null && ref !== void 0 ? ref : innerRef;
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n,
    ctxLocale = _useLocale.locale;
  var locale = (0, _locale.parseLocale)(ctxLocale, {
    fallback: 'en_US'
  });
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dateSplitObj = _useState2[0],
    setDateSplitObj = _useState2[1];
  var handleBlur = (0, _react.useCallback)(function () {
    setTimeout(function () {
      var _DobSelectorRef$curre;
      var activeElement = (0, _getActiveElement["default"])();
      !((_DobSelectorRef$curre = DobSelectorRef.current) !== null && _DobSelectorRef$curre !== void 0 && _DobSelectorRef$curre.contains(activeElement)) && (onBlur === null || onBlur === void 0 ? void 0 : onBlur());
    }, 0);
  }, [DobSelectorRef, onBlur]);
  var handleChange = (0, _react.useCallback)(function (name) {
    return function (arg) {
      var validDateSplitObj = calculateValidDateSplitObj(_objectSpread(_objectSpread({}, dateSplitObj), {}, (0, _defineProperty2["default"])({}, name, Number(arg))));
      setDateSplitObj(validDateSplitObj);
      if (isFullDate(validDateSplitObj)) {
        var year = validDateSplitObj.year,
          month = validDateSplitObj.month,
          day = validDateSplitObj.day;
        onChange === null || onChange === void 0 || onChange((0, _datetime.format)(propFormat)((0, _datetime.toISO)("".concat(year, "-").concat(month, "-").concat(day), 'YYYY-MM-DD')));
      }
    };
  }, [onChange, dateSplitObj, propFormat, setDateSplitObj]);
  (0, _react.useEffect)(function () {
    if ((0, _isFunction["default"])(registerValidate)) {
      registerValidate({
        required: function required(v) {
          return isFullDate(splitDate(v, propFormat)) ? '' : 'react-ui.validation.required';
        }
      });
    }
  }, [registerValidate, i18n, dateSplitObj, propFormat]);
  (0, _react.useEffect)(function () {
    setDateSplitObj(splitDate(dobValue, propFormat));
  }, [dobValue, propFormat]);
  var _useMemo = (0, _react.useMemo)(function () {
      return (0, _prop["default"])(locale)(DateTimeSymbols);
    }, [locale]),
    SHORTMONTHS = _useMemo.SHORTMONTHS;
  var sequence = (0, _react.useMemo)(function () {
    return createSequence(displayFormat || getShortDateFormat(locale));
  }, [displayFormat, locale]);
  var data = (0, _react.useMemo)(function () {
    return {
      year: (0, _reverse["default"])(createMenuDataList(minYear, maxYear)),
      month: SHORTMONTHS.map(function (month, key) {
        return {
          text: month,
          value: "".concat(key + 1)
        };
      }),
      day: createMenuDataListOfDays(dateSplitObj.month, dateSplitObj.year)
    };
  }, [SHORTMONTHS, dateSplitObj, minYear]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('date-of-birth flex gap-6', className),
    ref: DobSelectorRef,
    "data-testid": "dobSelector-root"
  }, sequence.map(function (v) {
    return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({
      key: v,
      "data-testid": "dob-selector-".concat(v)
    }, rest, {
      size: size,
      value: dateSplitObj[v] !== undefined ? "".concat(dateSplitObj[v]) : null,
      onChange: handleChange("".concat(v)),
      placeholder: i18n("react-ui.form.dob.".concat(v)),
      onBlur: handleBlur
    }), /*#__PURE__*/_react["default"].createElement(_MenuItemList["default"], null, data[v].map(function (_ref3) {
      var text = _ref3.text,
        val = _ref3.value;
      return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: val,
        value: val
      }, text);
    })));
  }));
};
var _default = exports["default"] = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(DateOfBirthSelector);